module.exports = __webpack_public_path__ + "static/media/gallery-new-2.47a0d296.jpg";